import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import {
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  isBefore,
  addMonths,
  subMonths,
} from "date-fns";

const CustomDatePicker = ({ selectedDate, setSelectedDate, minDate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const generateMonthDays = (date) => {
    const start = startOfMonth(date);
    const end = endOfMonth(date);
    return eachDayOfInterval({ start, end });
  };

  const handleDateSelect = (date) => {
    if (!isBefore(date, minDate)) {
      setSelectedDate(date);
      setIsOpen(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <button
        type="button"
        className="w-full bg-deep-red text-white font-semibold py-3 px-6 rounded-xl hover:bg-bright-red transition-colors focus:outline-none focus:ring-2 focus:ring-deep-red/20"
        onClick={() => setIsOpen(true)}
      >
        {format(selectedDate, "PPP")}
      </button>

      {isOpen && (
        <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
          <div className="fixed inset-0 bg-dark-grey/50" aria-hidden="true"></div>
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="mx-auto max-w-md rounded-xl bg-white p-6 shadow-xl border border-light-grey">
              <Dialog.Title className="text-lg font-bold text-dark-grey mb-4">
                Select a Date
              </Dialog.Title>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-dark-grey">
                    {format(selectedDate, "MMMM yyyy")}
                  </h2>
                  <button
                    onClick={handleClose}
                    className="text-medium-grey hover:text-dark-grey font-medium"
                  >
                    Cancel
                  </button>
                </div>
                
                <div className="flex justify-between items-center gap-3">
                  <button
                    className="bg-deep-red hover:bg-bright-red text-white font-semibold py-2 px-4 rounded-lg transition-colors flex-1"
                    onClick={() => setSelectedDate(subMonths(selectedDate, 1))}
                  >
                    Previous
                  </button>
                  <button
                    className="bg-deep-red hover:bg-bright-red text-white font-semibold py-2 px-4 rounded-lg transition-colors flex-1"
                    onClick={() => setSelectedDate(addMonths(selectedDate, 1))}
                  >
                    Next
                  </button>
                </div>
                
                <div className="grid grid-cols-7 gap-1">
                  {generateMonthDays(selectedDate).map((day, index) => (
                    <button
                      key={index}
                      className={`py-3 px-2 rounded-lg text-sm font-medium transition-colors ${
                        isBefore(day, minDate)
                          ? "bg-light-grey/50 text-medium-grey cursor-not-allowed"
                          : "bg-light-grey/30 hover:bg-deep-red hover:text-white text-dark-grey"
                      } `}
                      onClick={() => handleDateSelect(day)}
                      disabled={isBefore(day, minDate)}
                    >
                      {format(day, "d")}
                    </button>
                  ))}
                </div>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default CustomDatePicker;
